/**
 * Minimalerei Member Page Calculator — Phase 3
 *
 * Interaktiver Slider mit Live-Berechnung: User dreht am Bestellwert,
 * sieht in Echtzeit Punkte + Gutschein-Wert. Welcome-Bonus wird auf
 * der Server-Seite per Liquid-Guard nur für Logged-out User gerendert
 * UND auf der Client-Seite in der Berechnung berücksichtigt.
 *
 * Mehrere Calculator-Instanzen auf einer Page sind unabhängig — jede
 * liest ihre Konfiguration aus den data-* Attributen ihres eigenen
 * Section-Wrappers.
 */

(function () {
  'use strict';

  function initCalculator(calc) {
    // === Config aus data-* lesen ===
    const pointsPerEuro = parseFloat(calc.dataset.pointsPerEuro) || 5;
    const pointsPerEuroVoucher = parseFloat(calc.dataset.pointsPerEuroVoucher) || 100;
    const welcomeBonusPoints = parseFloat(calc.dataset.welcomeBonusPoints) || 300;
    const minValue = parseFloat(calc.dataset.minValue) || 0;
    const maxValue = parseFloat(calc.dataset.maxValue) || 200;
    // Liquid serialisiert Booleans als 'true'/'false' Strings → String-Vergleich.
    const isLoggedIn = calc.dataset.isLoggedIn === 'true';

    const slider = calc.querySelector('[data-mp-calc-slider]');
    const valueDisplay = calc.querySelector('[data-mp-calc-value]');
    const fill = calc.querySelector('[data-mp-calc-fill]');
    const thumb = calc.querySelector('[data-mp-calc-thumb]');
    const pointsPurchaseDisplay = calc.querySelector('[data-mp-calc-points-purchase]');
    const voucherDisplay = calc.querySelector('[data-mp-calc-voucher]');

    if (
      !slider ||
      !valueDisplay ||
      !fill ||
      !thumb ||
      !pointsPurchaseDisplay ||
      !voucherDisplay
    ) {
      return;
    }

    /**
     * "5.49" → "5,49 €" (deutsches Format mit hinten stehenden Euro)
     */
    function formatEuro(amount) {
      const formatted = amount.toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return formatted + ' €';
    }

    /**
     * "1250" → "1.250" (deutscher Tausender-Separator)
     */
    function formatNumber(num) {
      return Math.round(num).toLocaleString('de-DE');
    }

    function calculate(orderValue) {
      const pointsFromPurchase = orderValue * pointsPerEuro;
      let totalPoints = pointsFromPurchase;

      if (!isLoggedIn) {
        totalPoints += welcomeBonusPoints;
      }

      const voucherValue = totalPoints / pointsPerEuroVoucher;

      return { pointsFromPurchase, totalPoints, voucherValue };
    }

    function updateDisplay() {
      const value = parseFloat(slider.value);

      // Fill + Thumb proportional zum Slider-Wert positionieren.
      // (Browser-Native-Slider hat opacity:0 und liegt darüber für
      // Interaktion — die sichtbaren Custom-Elemente müssen wir
      // selbst auf den Wert syncen.)
      const percent = ((value - minValue) / (maxValue - minValue)) * 100;
      fill.style.width = percent + '%';
      thumb.style.left = percent + '%';

      valueDisplay.textContent = formatEuro(value);

      const result = calculate(value);
      pointsPurchaseDisplay.textContent = formatNumber(result.pointsFromPurchase);
      voucherDisplay.textContent = formatEuro(result.voucherValue);
    }

    slider.addEventListener('input', updateDisplay);
    slider.addEventListener('change', updateDisplay);

    updateDisplay();
  }

  function init() {
    const calculators = document.querySelectorAll('[data-mp-member-calc]');
    calculators.forEach(initCalculator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
